/**
 * Encounter Preview Modal
 *
 * Displays encounter details when stepping on an encounter hex.
 * Allows the player to enter battle or go back.
 */

import React from 'react';

interface EncounterPreviewModalProps {
  encounter: {
    name: string;
    narrative: string;
    mode: string;
    difficulty: string;
    previewHint: string;
    enemyRefs: Array<{ concept: string; count: number; difficultyTier: string }>;
  };
  encounterId: string;
  onEnterBattle: () => void;
  onClose: () => void;
}

export const EncounterPreviewModal: React.FC<EncounterPreviewModalProps> = ({
  encounter,
  encounterId: _encounterId,
  onEnterBattle,
  onClose,
}) => {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0, 0, 0, 0.8)',
        zIndex: 200,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#1e1e3a',
          border: '2px solid #4a3728',
          borderRadius: '16px',
          padding: '2rem',
          maxWidth: '500px',
          width: '90%',
          color: '#fff',
        }}
        onClick={e => e.stopPropagation()}
      >
        <h2 style={{ color: '#FFD700', marginBottom: '0.5rem', margin: '0 0 0.5rem' }}>
          {encounter.name}
        </h2>

        <p style={{
          color: 'rgba(255, 255, 255, 0.8)',
          fontStyle: 'italic',
          marginBottom: '1rem',
        }}>
          &quot;{encounter.narrative}&quot;
        </p>

        <div style={{ marginBottom: '0.75rem' }}>
          <span style={{ color: '#aaa' }}>Difficulty: </span>
          <span>{encounter.difficulty}</span>
          <span style={{ marginLeft: '1rem', color: '#aaa' }}>Mode: </span>
          <span>{encounter.mode.replace(/_/g, ' ')}</span>
        </div>

        {encounter.previewHint && (
          <p style={{
            color: '#fbbf24',
            fontSize: '0.9rem',
            marginBottom: '1rem',
          }}>
            Hint: {encounter.previewHint}
          </p>
        )}

        <div style={{ marginBottom: '1.5rem' }}>
          <h4 style={{ color: '#aaa', marginBottom: '0.5rem', margin: '0 0 0.5rem' }}>
            Enemies
          </h4>
          {encounter.enemyRefs.map((ref, i) => (
            <div key={i} style={{ fontSize: '0.9rem' }}>
              {ref.concept} x{ref.count}
              <span style={{ color: '#888', marginLeft: '0.5rem' }}>
                ({ref.difficultyTier})
              </span>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '0.5rem 1.5rem',
              background: '#333',
              color: '#fff',
              border: '1px solid #555',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
          >
            Back
          </button>
          <button
            onClick={onEnterBattle}
            style={{
              padding: '0.5rem 1.5rem',
              background: 'linear-gradient(135deg, #4a3728, #6b4f3a)',
              color: '#FFD700',
              border: '2px solid #8B6914',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold',
            }}
          >
            Enter Battle
          </button>
        </div>
      </div>
    </div>
  );
};
